import { FC } from 'react';
import cx from 'classnames/bind';

import styles from './Tooltip.module.scss';

const cn = cx.bind(styles);

const Tooltip: FC = () => (
  <div className={cn('tooltip')}>
    <div className={cn('text')}>Чтобы начать сценарий</div>
    <div className={cn('condition')}>Нажми на «Продолжение описания»</div>
  </div>
);

export default Tooltip;
